module.exports = __webpack_public_path__ + "img/Villani.f7effa56.jpeg";